/**
 * Payment-related constants
 */

export const PAYMENT_CONSTANTS = {
  /**
   * Minimum amount in dollars required to process payment.
   * Below this amount, payment is skipped.
   */
  MIN_PAYMENT_AMOUNT: 0.5,

  /**
   * Multiplier to convert dollar amounts to cents for Stripe API
   */
  STRIPE_CENTS_MULTIPLIER: 100,

  /**
   * Default currency code when not specified
   */
  DEFAULT_CURRENCY: 'USD',
} as const;

/**
 * Utility functions for currency conversion
 */

/**
 * Convert dollar amount to cents for Stripe API
 * @param amount Amount in dollars
 * @returns Amount in cents
 */
export const convertToStripeCents = (amount: number): number => {
  return Math.round(amount * PAYMENT_CONSTANTS.STRIPE_CENTS_MULTIPLIER);
};

/**
 * Convert cents to dollar amount
 * @param cents Amount in cents
 * @returns Amount in dollars
 */
export const convertFromStripeCents = (cents: number): number => {
  return cents / PAYMENT_CONSTANTS.STRIPE_CENTS_MULTIPLIER;
};

/**
 * Check if payment is required based on amount
 * @param amount Total amount in dollars
 * @returns True if payment processing is required
 */
export const isPaymentRequired = (amount: number): boolean => {
  return amount >= PAYMENT_CONSTANTS.MIN_PAYMENT_AMOUNT;
};
